import React from 'react'
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import {Accordion, AccordionDetails, AccordionSummary} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import {confirmAlert} from "react-confirm-alert";
import AppToast from "../../ui/AppToast";
import {getFormData} from "../../helpers/Helpers";

class DocumentacionPaquete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };

    }

    componentDidMount() {
        let expandend = 1;
        if (this.props.documentosPorPaquete.length > 1) {
            expandend = 0;
        }
        this.setState({
            expanded: expandend
        });
    }

    handleChangeAccordion = (numeroPaquete) => (event, isExpanded) => {
        this.setState({
            expanded: isExpanded ? numeroPaquete : false
        });
    }

    adicionarPaquete = async () => {

        const numeroPaquetes = this.props.documentosPorPaquete.length;
        let indexUltimoPaquete = null;
        let objUltimoPaquete = null;
        if (numeroPaquetes > 0) {
            indexUltimoPaquete = numeroPaquetes - 1;
            objUltimoPaquete = this.props.documentosPorPaquete[indexUltimoPaquete];

            if (!this.props.validarDocumentacionPaquete(objUltimoPaquete.data)) {
                return false;
            }
        }

        let params = {
            solicitudPasoID: this.props.solicitudPasoID,
            paquete: JSON.stringify(objUltimoPaquete)
        };
        params = this.props.configurarEnvioDocumentosPaquete(objUltimoPaquete.numero_paquete, objUltimoPaquete.data, params);
        const formData = getFormData(params);
        const response = await Api.postWithoutFormData(`${Env.UrlBackendCuentaNueva}/documento-paquete/adicionar`, formData);
        if (response.success) {
            AppToast(response.message, true);
            if (indexUltimoPaquete) {
                this.props.documentosPorPaquete[indexUltimoPaquete] = response.paquete_subido;
            }
            this.props.adicionarPaquete(response.data);
            this.setState({expanded: response.data.numero_paquete});
        } else {
            AppToast(response.message, false);
        }
    }

    borrarPaquete = async (numeroPaquete) => {

        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <p>¿Está seguro(a) de borrar el <b>Paquete No. {numeroPaquete}</b>?
                            <br/><br/> Esta acción no se puede reversar.</p>
                        <button onClick={onClose}>No</button>
                        <button className='custom-ui-btn-si'
                                onClick={async () => {

                                    const params = {
                                        numeroPaquete,
                                        solicitudPasoID: this.props.solicitudPasoID,
                                        minimoPaquetes: this.props.minimoPaquetes,
                                    };
                                    const response = await Api.post(`${Env.UrlBackendCuentaNueva}/documento-paquete/borrar`, params);
                                    if (response.success) {
                                        AppToast(response.message, true);
                                        this.props.borrarPaquete(numeroPaquete, response.validarMinimoPaquete);
                                    } else {
                                        AppToast(response.message, false);
                                    }

                                    onClose();

                                }}
                        >
                            Si
                        </button>
                    </div>
                );
            }
        });
    }

    render() {
        const {minimoPaquetes, documentosPorPaquete, handleChangeFilesDinamic, verArchivo, borrarArchivo} = this.props;
        return (
            (minimoPaquetes > 0 && documentosPorPaquete.length > 0) ?
                <div style={{border: '1px solid #ccc', marginBottom: '20px', borderRadius: '10px'}}>

                    <div style={{
                        background: '#0098DB',
                        color: 'white',
                        padding: '10px',
                        fontWeight: 'bold',
                        fontSize: '20px',
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px'
                    }}>
                        Documentación por paquetes
                    </div>

                    {
                        documentosPorPaquete.length > 0 ?
                            <div style={{padding: '10px', maxHeight: '500px', overflowY: 'auto'}}>
                                {documentosPorPaquete.map((documentos, i) => {
                                    return (
                                        <Accordion key={i}
                                                   expanded={this.state.expanded === documentos.numero_paquete}
                                                   onChange={this.handleChangeAccordion(documentos.numero_paquete)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon/>}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <div>
                                                <span style={{display: 'inline-block', fontWeight: 'bold'}}>
                                                    Paquete No. {documentos.numero_paquete}
                                                </span>

                                                    {
                                                        documentos.numero_paquete > 1 ?
                                                            <div style={{display: 'inline-block', marginLeft: '30px'}}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    size="small"
                                                                    startIcon={<Icon>delete</Icon>}
                                                                    style={{marginRight: '10px', background: '#f44336'}}
                                                                    onClick={() => {
                                                                        this.borrarPaquete(documentos.numero_paquete)
                                                                    }}>
                                                                    Borrar Paquete
                                                                </Button>
                                                            </div>
                                                            : null
                                                    }

                                                </div>
                                            </AccordionSummary>

                                            <AccordionDetails>
                                                <Grid container spacing={2}>
                                                    {
                                                        documentos.data.map((val, index) => {

                                                            if (val.url_documentos) { // Si ya tiene un documento adjunto
                                                                return (
                                                                    <Grid item xs={12} sm={6} key={index}>
                                                                        <div style={{
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '5px',
                                                                            marginBottom: '10px'
                                                                        }}>
                                                                            <label style={{fontSize: '11px'}}>
                                                                                {val?.documento?.nombre}

                                                                                <span style={{
                                                                                    color: '#4caf50',
                                                                                    marginLeft: '5px',
                                                                                    fontSize: '20px',
                                                                                    fontWeight: 'bold'
                                                                                }}>
                                                                                    &#10003;
                                                                                </span>

                                                                            </label>

                                                                            <div style={{padding: '10px'}}>

                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="secondary"
                                                                                    size="small"
                                                                                    startIcon={<Icon>visibility</Icon>}
                                                                                    style={{
                                                                                        marginRight: '10px',
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        verArchivo(val);
                                                                                    }}>
                                                                                    Ver
                                                                                </Button>

                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="secondary"
                                                                                    size="small"
                                                                                    startIcon={<Icon>delete</Icon>}
                                                                                    style={{
                                                                                        marginRight: '10px',
                                                                                        background: '#f44336'
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        borrarArchivo(val);
                                                                                    }}>
                                                                                    Borrar
                                                                                </Button>
                                                                            </div>

                                                                        </div>
                                                                    </Grid>
                                                                );
                                                            } else { // Si NO tiene un documento adjunto
                                                                return (<Grid item xs={12} sm={6} key={index}>
                                                                        <div style={{
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '5px',
                                                                            marginBottom: '10px'
                                                                        }}>
                                                                            <label
                                                                                style={{fontSize: '11px'}}>{val?.documento?.nombre}
                                                                                <span className='file-obligatorio'>
                                                                                    {val.requerido === '1' ? ' * ' : ''}
                                                                                </span>
                                                                            </label>
                                                                            <input type="file"
                                                                                   style={{padding: '10px'}}
                                                                                   onChange={(e) => handleChangeFilesDinamic(e, val, 1)}/>

                                                                            <Alert severity="info"
                                                                                   style={{textAlign: 'left'}}>
                                                                                {
                                                                                    val?.documento?.link_formato ?
                                                                                        <span>
                                                                                            * Descargar Formato &nbsp;
                                                                                            <a rel="noopener noreferrer"
                                                                                               href={val.documento.link_formato}
                                                                                               target='_blank'>aquí</a>
                                                                                        </span>
                                                                                        : null
                                                                                }
                                                                                {
                                                                                    val?.documento?.descripcion_formato ?
                                                                                        <span>* {val?.documento?.descripcion_formato}</span>
                                                                                        : null
                                                                                }
                                                                                * El tamaño máximo permitido es
                                                                                de {val?.documento?.tamanio} megas<br/>
                                                                                * Extensiones
                                                                                permitidas: {val?.documento?.tipos}
                                                                            </Alert>

                                                                        </div>
                                                                    </Grid>
                                                                );
                                                            }
                                                        })
                                                    }
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    );
                                })}

                            </div>
                            : <p style={{fontWeight: '500'}}>¡Ningún paquete agregado!</p>
                    }

                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        startIcon={<Icon>add</Icon>}
                        style={{margin: '10px', background: '#4caf50'}}
                        onClick={this.adicionarPaquete}
                    >
                        Adicionar Paquete
                    </Button>

                </div>

                : null
        );
    }
}

export default DocumentacionPaquete
